import {useEffect, useRef} from "react";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const panicAudio = new Audio(getAssetPath("sounds/panic-notification.mp3"));
const chatAudio = new Audio(getAssetPath("sounds/chat-notification.wav"));

const playAudio = audio => {
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") playPromise.catch(() => {});
};

const isPanicAttendance = attendance => attendance.attendanceType === "panic" || attendance.isPanic === true;

const useDashboardAlerts = ({attendances = [], isReady = false, isChatSilenced = false}) => {
    const playedPanicIdsRef = useRef(new Set());
    const playedChatIdsRef = useRef(new Set());
    const initializedRef = useRef(false);
    const isChatSilencedRef = useRef(isChatSilenced);

    useEffect(() => {
        isChatSilencedRef.current = isChatSilenced;
    }, [isChatSilenced]);

    useEffect(() => {
        if (!isReady) return;

        let shouldPlayPanic = false;
        let shouldPlayChat = false;

        attendances.forEach(attendance => {
            const attendanceId = attendance?.attendanceId;
            if (attendanceId === null || attendanceId === undefined) return;

            if (isPanicAttendance(attendance) && !playedPanicIdsRef.current.has(attendanceId)) {
                playedPanicIdsRef.current.add(attendanceId);
                shouldPlayPanic = true;
            }

            if (attendance.hasChat && !attendance.chatFinalized && !playedChatIdsRef.current.has(attendanceId)) {
                playedChatIdsRef.current.add(attendanceId);
                shouldPlayChat = true;
            }
        });

        if (!initializedRef.current) {
            initializedRef.current = true;
            return;
        }

        if (shouldPlayPanic) playAudio(panicAudio);
        if (shouldPlayChat && !isChatSilencedRef.current) playAudio(chatAudio);
    }, [attendances, isReady]);
};

export default useDashboardAlerts;
